import CollapsableCard from "../../../common/components/CollapsableCard";
import { DEFAULT_ACTIVE_COLOR } from "../../../common/constants/color";
import NumericContainer from "./NumericContainer";
import FdesFormSelect from "./FdesFormSelect";
import PercentContainer from "./PercentContainer";
import {
  exportFdesFormToXlsx,
  importFdesFormFromXlsx,
} from "../../../utils/manageFdesForm";
import { ModalImportXlsx } from "./ModalImportXlsx";
import React, { useEffect, useState } from "react";
import CustomTooltip from "../../../common/components/CustomTooltip";

const FdesFormGroup = ({
  fdesParameterGroups,
  onChangeFdesParameterForm,
  fields,
  isAuto,
  readOnly,
  localConfigurator,
  uploadFile,
  calculName,
  updateFields,
  importFdesFormErrors,
  clearFieldsImportErrors,
  hasImportedFdesForm,
  closeImportFileModal,
  activeFdesId,
  model,
  userParametersGroups,
  updateFormGroupState,
  clearUserParametersGroups,
}) => {
  const activeColor =
    localConfigurator &&
    localConfigurator.theme &&
    localConfigurator.theme.colors &&
    localConfigurator.theme.colors.primaryText
      ? localConfigurator.theme.colors.primaryText
      : DEFAULT_ACTIVE_COLOR;
  const [isImportOpen, setIsImportOpen] = React.useState(false);

  useEffect(() => {
    return () => {
      clearUserParametersGroups();
    };
  }, [clearUserParametersGroups]);

  const handleDropFiles = async (files) => {
    importFdesFormFromXlsx(files, updateFields, isAuto, activeFdesId);
  };

  return (
    <>
      {(model?.settings?.userParametersInterface?.exportActive === true ||
        model?.settings?.userParametersInterface?.importActive === true) && (
        <div style={{ marginBottom: "1.875rem" }}>
          {model?.settings?.userParametersInterface?.exportActive === true && (
            <button
              className="btn btn-primary"
              onClick={() =>
                exportFdesFormToXlsx(fdesParameterGroups, fields, calculName)
              }
            >
              Exporter fichier Excel
            </button>
          )}
          {model?.settings?.userParametersInterface?.importActive === true &&
            !readOnly && (
              <>
                <button
                  className={`btn btn-primary ${model?.settings?.userParametersInterface?.exportActive === true ? "ml-1" : ""}`}
                  onClick={() => setIsImportOpen(true)}
                >
                  Importer fichier Excel
                </button>
                <ModalImportXlsx
                  isOpen={isImportOpen}
                  onClose={() => setIsImportOpen(false)}
                  onDrop={handleDropFiles}
                  importErrors={importFdesFormErrors}
                  hasImportedFdesForm={hasImportedFdesForm}
                  clearFieldsImportErrors={clearFieldsImportErrors}
                  closeImportFileModal={closeImportFileModal}
                />
              </>
            )}
          {model?.settings?.userParametersInterface?.helpText && (
            <>
              <i
                className="feather icon-info ml-1"
                data-tooltip-content={
                  model?.settings?.userParametersInterface?.helpText
                }
                data-tooltip-id="basicInput"
              />
              <CustomTooltip id="basicInput" place="right" />
            </>
          )}
        </div>
      )}
      {fdesParameterGroups &&
        fdesParameterGroups.length > 0 &&
        fdesParameterGroups.map(
          (parameterGroup, index) =>
            parameterGroup.parameters.filter(
              (parameter) =>
                (!parameter.visible && parameter.visible !== false) ||
                parameter.visible === true,
            ).length > 0 && (
              <FdesFormCard
                key={parameterGroup.name}
                parameterGroup={parameterGroup}
                activeColor={activeColor}
                fields={fields}
                onChangeFdesParameterForm={onChangeFdesParameterForm}
                isAuto={isAuto}
                readOnly={readOnly}
                activeFdesId={activeFdesId}
                uploadFile={uploadFile}
                userParametersGroups={userParametersGroups}
                updateFormGroupState={updateFormGroupState}
                index={index}
              />
            ),
        )}
    </>
  );
};

export default FdesFormGroup;

const FdesFormCard = ({
  parameterGroup,
  activeColor,
  fields,
  onChangeFdesParameterForm,
  isAuto,
  readOnly,
  activeFdesId,
  uploadFile,
  userParametersGroups,
  updateFormGroupState,
  index,
}) => {
  const [isCardOpen, setIsCardOpen] = useState();
  const userParamsGroup = userParametersGroups.find(
    (group) => group.name === parameterGroup.name,
  );

  useEffect(() => {
    if (userParamsGroup) {
      setIsCardOpen(userParamsGroup.isOpen);
    } else {
      setIsCardOpen(parameterGroup.parameters[0].groupIsOpen);
    }
  }, [userParamsGroup?.isOpen, parameterGroup.parameters]); //eslint-disable-line

  return (
    <CollapsableCard
      title={parameterGroup.name}
      classes="margin-scroll"
      defaultOpen={isCardOpen}
      onChangeOpen={(isOpen) =>
        updateFormGroupState(parameterGroup.name, isOpen, index)
      }
    >
      {parameterGroup &&
        parameterGroup.parameters &&
        parameterGroup.parameters.length > 0 &&
        parameterGroup.parameters.map(
          (parameter) =>
            ((!parameter.visible && parameter.visible !== false) ||
              parameter.visible === true) && (
              <fieldset className="form-group" key={parameter.name}>
                <label htmlFor={parameter._id}>
                  {parameter.name}
                  {parameter.helpText && parameter.helpText !== "" && (
                    <i
                      className="feather icon-info ml-1"
                      data-tooltip-content={parameter.helpText}
                      data-tooltip-id={parameter._id}
                    />
                  )}
                </label>
                {parameter.type === "select" && (
                  <FdesFormSelect
                    activeColor={activeColor}
                    fields={fields}
                    parameter={parameter}
                    onChangeFdesParameterForm={onChangeFdesParameterForm}
                    isAuto={isAuto}
                    readOnly={readOnly}
                    activeFdesId={activeFdesId}
                  />
                )}
                {parameter.type === "button" && (
                  <div className="button-container">
                    <div className="btn-group" role="group">
                      {parameter.values &&
                        parameter.values.map((label, value) => (
                          <button
                            key={value}
                            type="button"
                            disabled={readOnly}
                            className={`btn ${
                              fields &&
                              fields.find(
                                (x) => x.paramId === parameter.paramId,
                              ) &&
                              fields.find(
                                (x) => x.paramId === parameter.paramId,
                              ).value &&
                              fields.find(
                                (x) => x.paramId === parameter.paramId,
                              ).value.label === label
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() =>
                              onChangeFdesParameterForm(
                                parameter.paramId,
                                { value: label, label: label },
                                isAuto === "Y" && !parameter.isGeneralParameter,
                                activeFdesId,
                              )
                            }
                          >
                            {label}
                          </button>
                        ))}
                    </div>
                  </div>
                )}
                {(parameter.type === "numeric" ||
                  parameter.type === "numericslider") && (
                  <NumericContainer
                    type={parameter.type}
                    readOnly={readOnly}
                    validationRules={parameter?.validationRules}
                    defaultValue={
                      fields &&
                      fields.find((x) => x.paramId === parameter.paramId) &&
                      fields.find((x) => x.paramId === parameter.paramId).value
                        .value
                        ? fields.find((x) => x.paramId === parameter.paramId)
                            .value.value
                        : 0
                    }
                    onChange={(value) =>
                      onChangeFdesParameterForm(
                        parameter.paramId,
                        { value, label: value },
                        isAuto === "Y" && !parameter.isGeneralParameter,
                        activeFdesId,
                      )
                    }
                  />
                )}
                {(parameter.type === "percent" ||
                  parameter.type === "percentslider") && (
                  <PercentContainer
                    type={parameter.type}
                    readOnly={readOnly}
                    validationRules={parameter?.validationRules}
                    defaultValue={
                      fields &&
                      fields.find((x) => x.paramId === parameter.paramId) &&
                      fields.find((x) => x.paramId === parameter.paramId).value
                        .value
                        ? fields.find((x) => x.paramId === parameter.paramId)
                            .value.value
                        : 0
                    }
                    onChange={(value) =>
                      onChangeFdesParameterForm(
                        parameter.paramId,
                        {
                          value: (parseFloat(value) / 100)
                            .toString()
                            .replace(".", ","),
                          label: (parseFloat(value) / 100)
                            .toString()
                            .replace(".", ","),
                        },
                        isAuto === "Y" && !parameter.isGeneralParameter,
                        activeFdesId,
                      )
                    }
                  />
                )}
                {(parameter.type === "string" ||
                  parameter.type === "integer" ||
                  parameter.type === "decimal") && (
                  <input
                    type={parameter.type === "integer" ? "number" : "text"}
                    value={
                      fields &&
                      fields.find((x) => x.paramId === parameter.paramId) &&
                      fields.find((x) => x.paramId === parameter.paramId).value
                        .value
                    }
                    onChange={(e) =>
                      onChangeFdesParameterForm(
                        parameter.paramId,
                        {
                          value: e.target.value,
                          label: e.target.value,
                        },
                        isAuto === "Y" && !parameter.isGeneralParameter,
                        activeFdesId,
                      )
                    }
                    className="form-control"
                    id={parameter._id}
                    disabled={readOnly}
                  />
                )}
                {parameter.type === "text" && (
                  <input
                    type={parameter.type}
                    value={
                      fields &&
                      fields.find((x) => x.paramId === parameter.paramId) &&
                      fields.find((x) => x.paramId === parameter.paramId).value
                        .value
                    }
                    onChange={(e) =>
                      onChangeFdesParameterForm(
                        parameter.paramId,
                        {
                          value: e.target.value,
                          label: e.target.value,
                        },
                        isAuto === "Y" && !parameter.isGeneralParameter,
                        activeFdesId,
                      )
                    }
                    className="form-control"
                    disabled={readOnly}
                    maxLength={parameter.validationRules.maxLength}
                  />
                )}
                {parameter.type === "textarea" && (
                  <textarea
                    type={parameter.type}
                    value={
                      fields &&
                      fields.find((x) => x.paramId === parameter.paramId) &&
                      fields.find((x) => x.paramId === parameter.paramId).value
                        .value
                    }
                    onChange={(e) =>
                      onChangeFdesParameterForm(
                        parameter.paramId,
                        {
                          value: e.target.value,
                          label: e.target.value,
                        },
                        isAuto === "Y" && !parameter.isGeneralParameter,
                        activeFdesId,
                      )
                    }
                    className="form-control"
                    disabled={readOnly}
                    maxLength={parameter.validationRules.maxLength}
                    rows={4}
                  />
                )}
                {parameter.type === "image" && (
                  <div className="">
                    <input
                      type={"file"}
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={(e) => {
                        uploadFile(
                          parameter.paramId,
                          e.target.files[0],
                          isAuto === "Y" && !parameter.isGeneralParameter,
                          activeFdesId,
                        );
                      }}
                      className="form-control"
                      disabled={readOnly}
                    />
                    {fields &&
                      fields.find((x) => x.paramId === parameter.paramId) && (
                        <>
                          Image actuelle :{" "}
                          <div className="max-image">
                            <img
                              className="img-fluid"
                              alt="Logo"
                              src={
                                fields.find(
                                  (x) => x.paramId === parameter.paramId,
                                ).value.value
                              }
                            />
                          </div>
                        </>
                      )}
                  </div>
                )}
                {parameter.helpText && parameter.helpText !== "" && (
                  <CustomTooltip id={parameter._id} place="right" />
                )}
              </fieldset>
            ),
        )}
    </CollapsableCard>
  );
};
